import { HighlightStyle, syntaxHighlighting } from '@codemirror/language';
import { tags } from '@lezer/highlight';
import { EditorView } from '@codemirror/view';

const bg = '#000000';
const gutterBg = '#0a0a0a';
const gutterText = '#64748b';
const defaultText = '#e2e8f0';
const keyword = '#d8b4fe';
const name = '#fda4af';
const fn = '#7dd3fc';
const typeName = '#fde047';
const string = '#86efac';
const number = '#93c5fd';
const comment = '#78716c';
const operator = '#67e8f9';
const cursor = '#38bdf8';
const selection = '#334155';
const activeLine = '#0c1222';

const fileDrawerEditorTheme = EditorView.theme(
    {
        '&': {
            color: defaultText,
            backgroundColor: bg,
        },
        '.cm-content': { caretColor: cursor },
        '.cm-cursor, .cm-dropCursor': { borderLeftColor: cursor },
        '&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection':
            {
                backgroundColor: selection,
            },
        '.cm-activeLine': { backgroundColor: activeLine },
        '.cm-selectionMatch': { backgroundColor: '#1e3a2f' },
        '.cm-gutters': {
            backgroundColor: gutterBg,
            color: gutterText,
            border: 'none',
        },
        '.cm-activeLineGutter': { backgroundColor: activeLine },
        '.cm-foldPlaceholder': {
            backgroundColor: 'transparent',
            border: 'none',
            color: '#a8a29e',
        },
    },
    { dark: true },
);

const fileDrawerHighlightStyle = HighlightStyle.define([
    { tag: tags.keyword, color: keyword },
    {
        tag: [tags.name, tags.deleted, tags.character, tags.propertyName, tags.macroName],
        color: name,
    },
    { tag: [tags.function(tags.variableName), tags.labelName], color: fn },
    {
        tag: [tags.color, tags.constant(tags.name), tags.standard(tags.name)],
        color: '#fcd34d',
    },
    { tag: [tags.definition(tags.name), tags.separator], color: defaultText },
    {
        tag: [tags.typeName, tags.className, tags.number, tags.changed, tags.annotation, tags.modifier, tags.self, tags.namespace],
        color: typeName,
    },
    {
        tag: [
            tags.operator,
            tags.operatorKeyword,
            tags.url,
            tags.escape,
            tags.regexp,
            tags.link,
            tags.special(tags.string),
        ],
        color: operator,
    },
    { tag: [tags.meta, tags.comment], color: comment },
    { tag: tags.strong, fontWeight: 'bold' },
    { tag: tags.emphasis, fontStyle: 'italic' },
    { tag: tags.strikethrough, textDecoration: 'line-through' },
    { tag: tags.link, color: comment, textDecoration: 'underline' },
    { tag: tags.heading, fontWeight: 'bold', color: name },
    {
        tag: [tags.atom, tags.bool, tags.special(tags.variableName)],
        color: '#fcd34d',
    },
    { tag: [tags.processingInstruction, tags.string, tags.inserted], color: string },
    { tag: tags.invalid, color: '#fecaca' },
]);

/** Pure-black editor chrome + high-contrast highlighting for file drawers. */
export const fileDrawerCodeMirrorTheme = [fileDrawerEditorTheme, syntaxHighlighting(fileDrawerHighlightStyle)];
